import { createHttpEndpoint } from '../../utils'

/**
 * TODO Add link to API specs when available
 */
export const postIdentityDocuments = createHttpEndpoint({
  method: 'POST',
  operationId: 'setIdentityDocuments',
  path: '/bm/client/identity_documents',
  // TODO [PAYIN-2621] Add support for FormData
  // isFormData: true,
})

/**
 * TODO Add link to API specs when available
 */
export interface ClientBankDetailsPayload {
  bankDetailsDocument: string
  isBankDetailsDocumentDeletable: boolean
}

export const getBankDetails = createHttpEndpoint<ClientBankDetailsPayload>({
  method: 'GET',
  operationId: 'getClientBankDetails',
  path: '/bm/client/bank_details',
})

/**
 * TODO Add link to API specs when available
 */

export const putBankDetails = createHttpEndpoint<ClientBankDetailsPayload>({
  method: 'PUT',
  operationId: 'setBankDetailsDocument',
  path: '/bm/client/bank_details',
  // TODO [PAYIN-2621] Add support for FormData
  // isFormData: true,
})

/**
 * TODO Add link to API specs when available
 */
export const deleteBankDetails = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deleteBankDetailsDocument',
  path: '/bm/client/bank_details',
})
